import { useState } from 'react';
import { ShieldAlert } from 'lucide-react';

const LS_AGE = 'relatos.age';

/**
 * Age gate — one modal before the app mounts (same layer as PowGate).
 * The forum carries user-generated content that may be adult; entry requires
 * an affirmative 18+ confirmation. The affirmation timestamp is logged
 * locally (localStorage only — nothing is transmitted anywhere).
 */
export function AgeGate({ children }: { children: React.ReactNode }) {
  const [ok, setOk] = useState(() => {
    try { return !!localStorage.getItem(LS_AGE); } catch { return false; }
  });
  const [checked, setChecked] = useState(false);

  if (ok) return <>{children}</>;

  const affirm = () => {
    try { localStorage.setItem(LS_AGE, JSON.stringify({ affirmedAt: new Date().toISOString() })); } catch { /* private mode — gate shows again */ }
    setOk(true);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--rl-bg, #d8e0ea)', fontFamily: 'Tahoma, Verdana, sans-serif',
    }}>
      <div style={{
        background: '#fff', border: '1px solid #9db2c8', borderRadius: 3,
        padding: '28px 32px', maxWidth: 420, textAlign: 'center',
      }}>
        <ShieldAlert size={32} aria-hidden style={{ color: '#8a6d1d' }} />
        <h1 style={{ fontSize: 15, margin: '12px 0 6px' }}>Adults only</h1>
        <p style={{ fontSize: 12, color: '#555', margin: '0 0 12px' }}>
          Relatos is an uncensored forum. Boards may contain adult (18+) content.
          You must be of legal adult age in your jurisdiction to enter.
        </p>
        <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', textAlign: 'left', fontSize: 12, marginBottom: 12 }}>
          <input type="checkbox" checked={checked} onChange={e => setChecked(e.target.checked)} style={{ marginTop: 2 }} />
          <span>I affirm that I am at least 18 years old (or the age of majority in my jurisdiction)
            and I consent to seeing adult content.</span>
        </label>
        <button className="rl-btn rl-btn-primary" disabled={!checked} onClick={affirm} style={{ width: '100%' }}>
          Enter Relatos
        </button>
        <p style={{ fontSize: 11, color: '#888', margin: '10px 0 0' }}>
          By entering you agree to the <a href="#/tos" onClick={e => { e.preventDefault(); window.open(`${location.pathname}#/tos`, '_blank'); }}>Terms of Service</a>.
          Your affirmation is stored on this device only.
        </p>
      </div>
    </div>
  );
}
